module.exports = __webpack_public_path__ + "static/media/TW-GerardRoss-desktop-1220x1500@2x-80.7e9c7389.jpg";